import {Button} from "../../../basic/button";
import {Input} from "../../../basic/input";
import {Label} from "../../../basic/label";
import {Plus} from "lucide-react";
import {toast} from "sonner";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface AddUserFormProps {
    newUserId: string;
    setNewUserId: (value: string) => void;
    onAddUser: () => void;
    isLoading?: boolean;
}

export function AddUserForm({newUserId, setNewUserId, onAddUser, isLoading = false}: AddUserFormProps) {
    const {t} = useTranslationWithKeys();

    const handleAddUser = () => {
        if (!newUserId.trim()) {
            toast.error(t('admin.teams.teamManagement.errors.selectUser'));
            return;
        }

        onAddUser();
    };

    return (
        <div className="space-y-4 pt-4 border-t">
            <Label>{t('admin.teams.teamManagement.addUser')}</Label>
            <div className="flex gap-2">
                <Input
                    placeholder={t('admin.teams.teamManagement.enterUserId')}
                    value={newUserId}
                    onChange={(e) => setNewUserId(e.target.value)}
                    className="flex-1"
                />
                <Button onClick={handleAddUser} disabled={isLoading}>
                    <Plus className="h-4 w-4 mr-2"/>
                    {isLoading ? t('common.adding') : t('admin.teams.teamManagement.addUserButton')}
                </Button>
            </div>
            <p className="text-muted-foreground">
                {t('admin.teams.teamManagement.addUserDescription')}
            </p>
        </div>
    );
}
